module.exports = __webpack_public_path__ + "img/7.454c46c2.jpg";